import React, { useEffect, useState } from 'react';
import Header from '../../Components/Header/Header';
import Contact from '../../Components/Contact/Contact';
import ProjectsList from '../../Components/ProjectsList/ProjectsList';
import CareerContact from '../../Components/CareerContact/CareerContact';
import './Projects.scss';
import HeroText from '../../Components/HeroText/HeroText';
import Footer from '../../Components/Footer/Footer';
import { Helmet } from 'react-helmet';
import { CONSTANT, SEO } from '../../Utils/Constant';
import { trackPageView } from '../../Utils/mixpanel';
// import ProminentWorksList from '../../Utils/ProminentWorksList';

const Projects = () => {
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    trackPageView('Case Studies', { section: 'case_studies_list' });
  }, []);

  return (
    <>
      <Helmet>
        <title>{SEO.PROJECTS_PAGE_TITLE}</title>
        <meta name="description" content={SEO.PROJECTS_PAGE_DESCRIPTION} />
        <meta name="keywords" content={SEO.PROJECT_PAGE_KEYWORDS} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={window.location.href} />
        <meta property="og:title" content={SEO.PROJECTS_PAGE_TITLE} />
        <meta property="og:description" content={SEO.PROJECTS_PAGE_DESCRIPTION} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={CONSTANT.PIXERFECT_WEB_LINK} />
        <meta property="og:site_name" content={CONSTANT.PIXERFECT_SOLUTIONS_LLP} />
        <meta property="og:image" content="https://www.pixerfect.com/Group_192_192.png" />
        <meta property="twitter:image" content="https://www.pixerfect.com/Group_192_192.png" />
        <meta name="twitter:title" content={SEO.PROJECTS_PAGE_TITLE} />
        <meta name="twitter:description" content={SEO.PROJECTS_PAGE_DESCRIPTION} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Header />
      <HeroText
        title={'A Gallery of Our Software Success Stories'}
        content={
          'Explore our extensive portfolio of case studies, showcasing the unique challenges faced by businesses and how we helped overcome them.'
        }
      />
      <ProjectsList dataList={dataList} setDataList={setDataList} />
      {/* {ProminentWorksList.length === dataList.length && ( */}
      <>
        <Contact />
        <CareerContact />
        <Footer />
      </>
      {/* )} */}
    </>
  );
};

export default Projects;
